import React from 'react';

import classNames from 'classnames';
import DragIndicatorIcon from 'icons/drag-indicator.svg';
import PropTypes from 'prop-types';

import { useSortableRow } from 'components/contentRegister/components/sortableTable/components/SortableRow';

export default function DragHandle({ label }) {
  const {
    dragAttributes,
    dragListeners,
    isDragging,
    isSortable,
    setActivatorNodeRef,
  } = useSortableRow();

  if (!isSortable) return null;

  return (
    <div
      {...dragAttributes}
      {...dragListeners}
      aria-label={label}
      className={classNames(
        'tw-flex tw-h-6 tw-w-6 tw-touch-none tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-transparent focus-visible:tw-visible active:tw-bg-blue-050 group-hover:tw-visible',
        // Not `tw-visible` while dragging: Tailwind emits .invisible after .visible, so the hidden state would win and the handle would vanish mid-drag.
        isDragging ? 'tw-cursor-grabbing' : 'tw-invisible tw-cursor-grab',
      )}
      onClick={(event) => event.stopPropagation()}
      ref={setActivatorNodeRef}
    >
      <DragIndicatorIcon
        className='[&_path]:tw-fill-grey-700'
        height={12}
        width={8}
      />
    </div>
  );
}

DragHandle.propTypes = {
  label: PropTypes.string.isRequired,
};
